var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{class:[
    'docs-callout mb-4',
    { 'docs-callout--dark': _vm.isDarkDocsTheme },
  ],attrs:{"outlined":"","color":_vm.color}},[_c('div',{staticClass:"d-flex align-start"},[(_vm.icon)?_c('font-awesome-icon',{staticClass:"mr-2 mt-1",attrs:{"icon":_vm.icon,"size":"sm"}}):_vm._e(),_c('div',[_c('div',{staticClass:"subtitle-2 font-weight-bold mb-1"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"body-2"},[_vm._t("default")],2)])],1)])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }